var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{style:({
      'padding-top':
        _vm.$vuetify.breakpoint.name == 'xs'
          ? '10px'
          : _vm.$vuetify.breakpoint.name == 'sm'
          ? '100px'
          : _vm.$vuetify.breakpoint.name == 'md'
          ? '200px'
          : _vm.$vuetify.breakpoint.name == 'lg'
          ? '200px'
          : '200px',
    }),attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs11":"","sm4":"","md3":"","text-center":""}},[_c('v-img',{attrs:{"width":"250px","height":"200px","src":"https://thumbs.dreamstime.com/b/nelliyampathy-tea-estate-hill-view-211659812.jpg"}})],1),_c('v-flex',{attrs:{"xs11":"","sm5":"","md5":"","text-left":""}},[_c('span',{staticStyle:{"font-family":"sofiaProBold","font-size":"25px"}},[_vm._v(" Demo Test Test ")]),_c('br'),_c('span',{staticStyle:{"font-family":"sofiaProLight","font-size":"20px","line-height":"30px"}},[_vm._v(" Date: ")]),_c('span',{staticStyle:{"font-family":"sofiaProLight","font-size":"20px","color":"grey"}},[_vm._v("10 Sep 2022")]),_c('br'),_c('span',{staticStyle:{"font-family":"sofiaProLight","font-size":"20px","color":"grey"}},[_vm._v(" Description ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }